import React from "react"
import PropTypes from "prop-types"
import querystring from 'querystring';
import UserClientTaskRates from "./UserClientTaskRates";
import UserTaskClientRates from "./UserTaskClientRates";

class UserClientTaskContainer extends React.Component {
  constructor(props) {
    super(props);

    const clients = JSON.parse(this.props.clients)
    const members = JSON.parse(this.props.members)
    const tasks = JSON.parse(this.props.tasks)
    const taskUsers = JSON.parse(this.props.task_users)
    const clientTaskUsers = JSON.parse(this.props.client_task_users) || [];

    this.state = {
      clients,
      members,
      tasks,
      taskUsers,
      clientTaskUsers
    }
  }

  handleClientRate = (client_id, rate, billable, rate_changed) => {
    rate = (rate || rate === "$0.00") ? Number(String(rate).replace(/[^0-9.-]+/g,"")) : "";
    const { user_id, csrf } = this.props;

    const params = querystring.stringify({ user_id, client_id, rate, billable, rate_changed });
    const headers = new Headers({'X-CSRF-Token': csrf, 'Content-Type': 'application/json', 'Accept': 'application/json'})

    fetch("/client-rates?" + params, {method: "PATCH", headers})
      .then(result => result.json())
      .then((members) => this.setState({members}),
        (error) => { console.log(error) }
      )
  }

  handleTaskRate = (task_id, rate, billable, override, rate_changed) => {
    rate = (rate || rate === "$0.00") ? Number(String(rate).replace(/[^0-9.-]+/g,"")) : "";
    const { user_id, csrf } = this.props;

    const params = querystring.stringify({ user_id, task_id, rate, billable, override, rate_changed });
    const headers = new Headers({'X-CSRF-Token': csrf, 'Content-Type': 'application/json', 'Accept': 'application/json'})

    fetch("/task-user-rates?" + params, {method: "PATCH", headers})
      .then(result => result.json())
      .then((taskUsers) => this.setState({taskUsers}),
        (error) => { console.log(error) }
      )
  }

  handleClientTaskRate = (client_id, task_id, rate, billable, rate_changed) => {
    rate = (rate || rate === "$0.00") ? Number(String(rate).replace(/[^0-9.-]+/g,"")) : "";
    const component = this;
    const { user_id, csrf } = this.props;

    const params = querystring.stringify({ user_id, client_id, task_id, rate, billable, rate_changed });
    const headers = new Headers({
      'X-CSRF-Token': csrf,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })

    fetch("/client-task-rates?" + params, {method: "PATCH", headers})
      .then(result => result.json())
      .then((clientTaskUsers) => component.setState({clientTaskUsers}),
        (error) => { console.log(error) }
      )
  }

  addClients = (client, all_clients, clients, indent) => {
    client.indent = indent;
    clients.push(client);

    const subclients = all_clients.filter(c => c.parent_id === client.id)
    for (let index in subclients) {
      const subclient = subclients[index];
      this.addClients(subclient, all_clients, clients, indent+1)
    }
  }

  render () {
    const { handleTaskRate, handleClientRate, handleClientTaskRate } = this;
    const { clients: unsortedClients, tasks, clientTaskUsers, members, taskUsers } = this.state;
    const {
      user_rate: rate,
      client_name: clientName
    } = this.props;

    const user_rate = parseFloat(rate);

    let clients = [];
    const parents = unsortedClients.filter(c => c.parent_id === null);
    for (let index in parents) {
      const parent = parents[index];
      this.addClients(parent, unsortedClients, clients, 0)
    }

    return (
      <div>
        <UserClientTaskRates {...{
          clientName,
          clients,
          members,
          tasks,
          taskUsers,
          clientTaskUsers,
          handleClientRate,
          handleClientTaskRate,
          user_rate
        }} />
        <UserTaskClientRates {...{
          clientName,
          clients,
          members,
          tasks,
          taskUsers,
          clientTaskUsers,
          handleTaskRate,
          handleClientTaskRate,
          user_rate
        }} />
      </div>
    );
  }
}

UserClientTaskContainer.propTypes = {
  user_id: PropTypes.number,
  clients: PropTypes.string,
  members: PropTypes.string,
  tasks: PropTypes.string,
  task_users: PropTypes.string,
  client_name: PropTypes.string,
};
export default UserClientTaskContainer
